export default __webpack_public_path__ + "static/media/scales.a50286cc.svg";